import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import { useSidebar } from '../../context/SidebarContext'

const SIDEBAR_WIDTH = 280

export default function Layout() {
  const { isOpen, isMobile, close } = useSidebar()
  const location = useLocation()

  // Full-width routes (no max-width constraint, minimal padding)
  const isFullWidthRoute = location.pathname.startsWith('/api-reference')

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        {/* Mobile drawer */}
        {isMobile ? (
          <Drawer
            variant="temporary"
            open={isOpen}
            onClose={close}
            ModalProps={{ keepMounted: true }}
            sx={{
              '& .MuiDrawer-paper': {
                width: SIDEBAR_WIDTH,
                boxSizing: 'border-box',
                top: 64,
                height: 'calc(100vh - 64px)',
              },
            }}
          >
            <Sidebar />
          </Drawer>
        ) : (
          /* Desktop collapsible sidebar */
          <Box
            sx={{
              width: isOpen ? SIDEBAR_WIDTH : 0,
              flexShrink: 0,
              transition: 'width 0.2s ease-in-out',
              overflow: 'hidden',
            }}
          >
            <Sidebar />
          </Box>
        )}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isFullWidthRoute ? 0 : { xs: 2, sm: 3, md: 4 },
            bgcolor: 'background.default',
            overflowY: isFullWidthRoute ? 'hidden' : 'auto',
            height: 'calc(100vh - 64px)',
            transition: 'margin 0.2s ease-in-out',
          }}
        >
          {isFullWidthRoute ? (
            <Outlet />
          ) : (
            <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
              <Outlet />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}
